import { CButton, CCol, CForm, CFormGroup, CInput, CInputGroup, CInputGroupAppend, CInputGroupText, CLabel, CRow, CSelect } from '@coreui/react'
import React, { useState } from 'react'
import { isValidEmail, Limpiar, validarCedula } from './Tools'
import { Icon } from '@iconify/react'
import { CustomSelect } from 'src/security/OTP'
import { RegisterCustomSelect } from './RegisterCustomSelect'
import AxiosManager from 'src/config/axiosManager'
import { provinciasRD } from './RegisterMunicipios'
import validateDate from 'src/reusable/validateDate'
import NumberFormat from 'react-number-format'
import { RegisterStepLeft } from './RegisterStepLeft'

export const RegisterStep3 = ({ DataForm, handleChange, setDataForm, pais, onCancel, onSuccess }) => {
    const [consultando, setConsultando] = useState(false)
    const consultaRNC = async () => {
        setConsultando(true)
        AxiosManager.get("/rnc", { params: { q: DataForm.rnc } })
            .then(({ data }) => {
                console.log(data)
                setDataForm({
                    ...DataForm,
                    rnc: data.rnc,
                    nombre: data.nombre,
                    nombrecomercial: data.nombre
                });
            })
            .catch(() => { })
            .finally(() => setConsultando(false))
    };

    const valid = Limpiar(DataForm.nombre.toUpperCase()).length > 4
        && isValidEmail(DataForm.correo)
        && validateDate(DataForm.fechanacimiento)
        && Limpiar(DataForm.whatsapp).length === 11
        && Limpiar(DataForm.telefono).length === 10
        && ((pais === 1 && validarCedula(DataForm.cedula)) || pais !== 1)
        && Limpiar(DataForm.cargo.toUpperCase()).length > 2


    return (
        <CRow>
            <RegisterStepLeft DataForm={DataForm} />
            <CCol xs="12" md="7">
                <div className="text-md-left ">
                    <h3 className="text-primary">
                        Informacion del Representante.
                    </h3>
                    <p>
                        Agradecemos completar la información solicitada de forma clara, precisa y verídica. Este formulario está dividido en dos secciones: Información de la Cooperativa e Información del Representante. Todos los campos marcados con asterisco (*) son obligatorios.
                    </p>
                    <p></p>
                </div>

                <CRow>
                    <CCol xs="5" md="4">
                        <CLabel htmlFor="company"> Documento de Identidad</CLabel>
                        <CInput
                            name="cedula"
                            value={DataForm.cedula}
                            onChange={handleChange}
                            className={`mb-3 ${consultando ? "opaco cargando" : ""}`}
                            style={
                                pais === 1 && !validarCedula(DataForm.cedula)
                                    ? { borderColor: "red" }
                                    : pais !== 1 && Limpiar(DataForm.cedula).length > 5
                                        ? { borderColor: "red" } : {}
                            }
                        />
                    </CCol>
                    <CCol xs="5" md="4">
                        <CLabel htmlFor="company">  Fecha de Nacimiento :</CLabel>
                        <CInput
                            value={DataForm.fechanacimiento}
                            placeholder="fechanacimiento"
                            onChange={handleChange}
                            type='date'
                            name="fechanacimiento"
                            className={`mb-3 ${consultando ? "opaco cargando" : ""}`}
                            style={
                                validateDate(DataForm.fechanacimiento)
                                    ? {}
                                    : { borderColor: "red" }
                            }
                        />
                    </CCol>
                </CRow>


                <CRow>
                    <CCol xs="12">
                        <CLabel htmlFor="company"> Nombre completo del representante :</CLabel>
                        <CInput
                            value={DataForm.nombre}
                            placeholder="nombre"
                            onChange={handleChange}
                            name="nombre"
                            className={`mb-3 ${consultando ? "opaco cargando" : ""}`}
                            style={{
                                borderColor: Limpiar(DataForm.nombre.toUpperCase()).length > 4 ? '' : "red",
                            }}
                        />
                    </CCol>
                    <CCol xs="6">
                        <CLabel htmlFor="company"> Cargo que ocupa en la cooperativa :</CLabel>
                        <CInput
                            value={DataForm.cargo}
                            placeholder="cargo"
                            onChange={handleChange}
                            name="cargo"
                            className={`mb-3 ${consultando ? "opaco cargando" : ""}`}
                            style={{
                                borderColor: Limpiar(DataForm.cargo.toUpperCase()).length > 2 ? '' : "red",
                            }}
                        />
                    </CCol>
                    <CCol xs="6">
                        <CLabel htmlFor="company">  Whatsapp de contacto directo  (Formato Int.):</CLabel>

                        <NumberFormat
                            value={DataForm.whatsapp}
                            onChange={handleChange}
                            format="#-###-###-####"
                            mask="_"
                            name="whatsapp"
                            className={`form-control mb-3 ${consultando ? "opaco cargando" : ""}`}
                            style={{
                                borderColor: Limpiar(DataForm.whatsapp).length === 11 ? '' : "red",
                            }}
                        />
                    </CCol>


                    <CCol xs="6">
                        <CLabel htmlFor="company">  Teléfono de contacto directo :  </CLabel>
                        <NumberFormat
                            value={DataForm.telefono}
                            onChange={handleChange}
                            format="###-###-####"
                            mask="_"
                            name="telefono"
                            className={`form-control mb-3 ${consultando ? "opaco cargando" : ""}`}
                            style={{
                                borderColor: Limpiar(DataForm.telefono).length === 10 ? '' : "red",
                            }}
                        />
                    </CCol>
                    <CCol xs="6">
                        <CLabel htmlFor="company">  Correo electrónico del representante :</CLabel>
                        <CInput
                            value={DataForm.correo}
                            placeholder="correo"
                            onChange={handleChange}
                            name="correo"
                            className={`mb-3 ${consultando ? "opaco cargando" : ""}`}
                            style={{
                                borderColor: isValidEmail(DataForm.correo) ? "" : "red",
                            }}
                        />
                    </CCol>
                    <CCol xs="12">
                        <CLabel htmlFor="company">  Direccion del representante:</CLabel>
                        <CInput
                            value={DataForm.direccion}
                            placeholder="direccion"
                            onChange={handleChange}
                            name="direccion"
                            className={`mb-3 ${consultando ? "opaco cargando" : ""}`}
                        />
                    </CCol>
                </CRow>



                <div
                    className="row justify-content-center"
                    style={{ flexFlow: "row", paddingTop: 50 }}
                >
                    <CButton
                        type="submit"
                        style={{ background: 'red', height: 60, padding: 0, margin: 0 }}
                        className="btn-block LoginInput2"
                        onClick={onCancel}
                    >
                        <Icon icon="icon-park-twotone:back" width={25} /> Atras
                    </CButton>
                    <CButton
                        type="submit"
                        color="primary"
                        style={{ height: 60, padding: 0, margin: 0 }}
                        className="btn-block LoginInput2"
                        onClick={onSuccess}
                        disabled={!valid}
                    >

                        Siguiente
                        <Icon icon="fluent:presence-available-10-regular" width={25} style={{ marginLeft: 10 }} />
                    </CButton>
                </div>
            </CCol>
        </CRow>
    )
}
